import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SnCamera } from '@lib/api/entities';
import { SnCamerasAPI } from '@lib/api/services';
import { SnCurrentOrganization } from '@lib/auth';
import { snZoomIn } from '@lib/common/animations';
import { GoogleMap } from '@lib/geo/google/map';

import { SnCameraMarker } from '../../map/camera-marker';

@Component({
  selector: 'sn-fusus-camera-event',
  templateUrl: './fusus-camera-event.container.html',
  styleUrls: ['./fusus-camera-event.container.scss'],
  animations: [snZoomIn],
})
export class FususCameraEventComponent implements OnInit, OnDestroy {
  public camera: SnCamera;
  public cameras = [];
  public googleMapCenter;
  public eventData = [];
  public objects = [];
  public isLoading: boolean = false;
  private _cameraMarker: SnCameraMarker;
  private _map: GoogleMap;
  private readonly _destroy$ = new Subject();

  constructor(
    private readonly _cameraAPI: SnCamerasAPI,
    private readonly _currentOrganization: SnCurrentOrganization,

    private readonly _activatedRoute: ActivatedRoute,
  ) {
    this.googleMapCenter = this._currentOrganization.settings.geometry.coordinates;
  }

  public ngOnInit(): void {
    this._fetchCameras();
  }
  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onMapInit(googleMap: GoogleMap): void {
    this._map = googleMap;
    this._cameraMarker = new SnCameraMarker(this.camera);
    this._cameraMarker.addTo(this._map);
  }
  private _fetchCameras(): void {
    this.isLoading = true;
    const cameraId = this._activatedRoute.snapshot.paramMap.get('id');

    this._cameraAPI
      .getCamera(cameraId)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (camera) => {
          this.camera = camera;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }
}
